import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@enviroment/environment';
import { AuthLoginRequest } from '@core/models/Http/Request/AuthLoginRequest';
import { DefaultResponse } from '@core/models/Http/DefaultResponse';
import { AuthManagementService } from '@core/service/auth-management.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly policiesSessionStorageKey = 'rmd.loginPolicies.sessionId';

  constructor(private http: HttpClient, private authMservice: AuthManagementService) {}

  login(data: AuthLoginRequest) {
    return this.http.post<DefaultResponse<any>>(
      `${environment.backend_url}Auth/login`,
      data
    );
  }

  acceptPendingLoginPolicy(data: {
    idUsuario: string;
    tipo: string;
    canal: 'WEB';
    sessionId: string;
    deviceId: string | null;
  }) {
    return this.http.post<DefaultResponse<any>>(
      `${environment.backend_url}PoliticasPrivacidad/aceptar`,
      data
    );
  }

  getOrCreateLoginPoliciesSessionId(): string {
    const existing = this.readPoliciesSessionId();
    if (existing) {
      return existing;
    }

    const generated = this.generateSessionId();
    this.writePoliciesSessionId(generated);
    return generated;
  }

  sendResetPasswordEmail(email: string, usr: string) {
    return this.http.post<DefaultResponse<string>>(
      `${environment.backend_url}Auth/forgot-password`,
      { email, usr }
    );
  }

  /**
   * RESET PASSWORD (FLUJO "OLVIDÉ MI CONTRASEÑA")
   * Endpoint: Auth/reset-password
   * Body: { token, newPassword, confirmPassword }
   */
  resetPassword(token: string, newPassword: string, confirmPassword: string) {
    return this.http.post<DefaultResponse<string>>(
      `${environment.backend_url}Auth/reset-password`,
      { token, newPassword, confirmPassword }
    );
  }

  /** Usa el token de transporte (iv:cipherText) en Authorization */
  refreshToken() {
    const transportToken = this.authMservice.getUserKey(); // iv:cipherText

    const headers = new HttpHeaders({
      Authorization: `Bearer ${transportToken ?? ''}`,
    });

    return this.http.post<DefaultResponse<any>>(
      `${environment.backend_url}Auth/renew`,
      null,
      { headers }
    );
  }

  private readPoliciesSessionId(): string | null {
    try {
      return localStorage.getItem(this.policiesSessionStorageKey);
    } catch {
      return null;
    }
  }

  private writePoliciesSessionId(value: string): void {
    try {
      localStorage.setItem(this.policiesSessionStorageKey, value);
    } catch {
    }
  }

  private generateSessionId(): string {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }

    return `rmd-${Date.now()}-${Math.random().toString(16).slice(2, 10)}`;
  }
}
